import React from "react";
import styled from '@emotion/styled';
import CardsResources from "./CardsResources";
import { motion } from "framer-motion";

const Resources = () => {


  const Title = styled(motion.p)`
  font-family: "Oswald", serif;
  font-size: 35px;
  color: black;
  border-bottom: 3px solid #005522;
  display: inline-block;
`;


const ResourcesDiv = styled.div`
    background: #ededed;
    padding-bottom: 50px;
`;

const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    padding: 20px;
    width: 80%;
    margin: auto;
`;



  return (
    <ResourcesDiv>
    <Title initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.6, ease: "easeOut" }}
    viewport={{ once: true }}> RECURSOS</Title>
    <Descripcion>Descarga los documentos oficiales emitidos desde la Coordinación Nacional de Capacitación para todos los Asociados.</Descripcion>
    <CardsResources/>
    </ResourcesDiv>
  );
}

export default Resources;